import { graphql } from 'msw';

import { hasValidToken } from '../utils';

export const getChargebeeSubscriptionSettings = graphql.query<
    GetChargebeeSubscriptionSettingsQuery,
    GetChargebeeSubscriptionSettingsQueryVariables
>('getChargebeeSubscriptionSettings', (req, res, ctx) => {
    if (hasValidToken(req, 'publisher')) {
        return res(
            ctx.data({
                getChargebeeSubscriptionSettings: {
                    subscription_active: true,
                    subscription_detection_tracks: 0,
                    subscription_expiration_date: '2100-11-12T14:01:55.121Z',
                    subscription_plan_type:
                        'CHARGEBEE_PLAN_PUBLISHER' as ChargebeePlanId,
                    subscription_royalty_capacity: 100000000,
                },
            }),
        );
    }

    return res();
});
